import React from 'react';
import { connect } from 'react-redux';
import { getCurrentDate } from '../../helpers/Common';
import { handleExport } from '../../helpers/HandleExport';
import { I18n } from 'react-redux-i18n';
import { REDUCER_NAME } from './reducer';
import { formatDate } from '../../helpers/DateTime';
import ownershipService from '../../../core/services/Fundamental/OwnerShip';
import {
  formatPrice,
  formatTextFloat,
  formatPercent,
} from '../../helpers/Text';
import Const from './Const';
import { Export } from './../../common/export';

class ExportCsv extends React.Component {
  getSchemaKey = indexSelectTab => {
    if (indexSelectTab === Const.listTab.MajorShareHolders.Index) {
      return Const.listTitleTableMajorShareHolders;
    }
    return Const.listTitleTableBOD;
  };

  getDataTableByTab = indexSelectTab => {
    const { listMajorShareHolders, listBoardOfDirectors } = this.props;
    if (indexSelectTab === Const.listTab.MajorShareHolders.Index) {
      return listMajorShareHolders;
    }
    return listBoardOfDirectors;
  };

  getPatchOfFileNameExport = indexSelectTab => {
    if (indexSelectTab === Const.listTab.MajorShareHolders.Index) {
      return Const.listTab.MajorShareHolders.Name;
    }
    return Const.listTab.BoardOfDirectors.Name;
  };

  formatData = data => {
    let formatData = data;
    formatData.forEach(item => {
      item.publicDate = formatDate(item.publicDate);
      item.percentage = formatPercent(formatTextFloat(item.percentage)) + '%';
      item.quantity = formatTextFloat(formatPrice(item.quantity));
    });
    return formatData;
  };

  initialInforExportCsv = () => {
    const { indexSelectTab, currentSearch } = this.props;
    const fileName = I18n.t('common.export.ownership.' + indexSelectTab, {
      ticker: currentSearch.displayCode,
      date: getCurrentDate(),
    });
    const params = {
      OrganCode: currentSearch.code,
    };
    if (indexSelectTab === 2) {
      ownershipService.exportBod(params).then(data => {
        handleExport(data, fileName);
      });
    } else {
      ownershipService
        .exportMajorShareHolder(params)
        .then(data => handleExport(data, fileName));
    }
  };

  render() {
    return <Export exportAction={this.initialInforExportCsv} />;
  }
}

const mapStateToProps = (state, { id }) => {
  return {
    i18n: state.i18n,
    listMajorShareHolders:
      state[REDUCER_NAME].listMultiComponent[id].listMajorShareHolders,
    listBoardOfDirectors:
      state[REDUCER_NAME].listMultiComponent[id].listBoardOfDirectors,
    currentSearch: state[REDUCER_NAME].listMultiComponent[id].currentSearch,
  };
};

export default connect(mapStateToProps)(ExportCsv);
